import { render, staticRenderFns } from "./Getiri.vue?vue&type=template&id=0909aaf0&"
import script from "./Getiri.vue?vue&type=script&lang=js&"
export * from "./Getiri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports